export const GENERIC_ERROR = 'UNKNOWN_OR_GENERIC_ERROR';

const PbValidationErrors = [
    GENERIC_ERROR,
    'INCOMPATIBLE_CONTRACTUAL_TYPE',
    'CONTRACTUAL_TYPE_MISSING',
    'CONTRACTUAL_TYPE_MISMATCH',
] as const;

export type PbValidationError = (typeof PbValidationErrors)[number];

export function isPbValidationError(
    error: unknown
): error is PbValidationError {
    if (typeof error !== 'string') {
        return false;
    }
    return (PbValidationErrors as readonly string[]).includes(error);
}

export function toPbValidationErrors(
    values?: unknown[]
): Set<PbValidationError> {
    if (!values) {
        return new Set();
    }
    return new Set(
        values.map((it) => (isPbValidationError(it) ? it : GENERIC_ERROR))
    );
}
